/**
 * Adds a specified number of days to a given date string
 */
export const addDaysToDateString = (dateString: string, days: number): Date => {
  const date = new Date(`${dateString}T00:00:00`)
  return new Date(date.setDate(date.getDate() + days))
}

/**
 * Converts a date string from "MM/DD/YYYY" to "YYYY-MM-DD"
 */
export const convertToISO8601 = (dateStr: string): string =>
  new Date(dateStr).toISOString().split('T')[0]

/**
 * Converts a Date object to a string "YYYY-MM-DD"
 */
export const convertDateToISO8601String = (date: Date): string => {
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

/**
 * Returns today's date in "YYYY-MM-DD" format
 */
export const today = (): string => new Date().toISOString().split('T')[0]

export const formatDateAsMMDDYYYY = (date: Date): string => {
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')
  const year = date.getUTCFullYear()
  return `${month}/${day}/${year}`
}
